/**
 * Lancement d'appel externe (clic-to-dial).
 *
 * Un appel SORTANT déclenche le composeur natif via `tel:` — exactement comme
 * un clic sur une ancre `<a href="tel:…">` (le protocole est confié à l'OS,
 * sans navigation de la SPA). Un appel entrant ou en visio ne lance rien.
 */
export function launchExternalCall(direction, phone) {
  // Seul un appel sortant compose un numéro (entrant = le client appelle ; visio ≠ tel).
  if (direction !== 'sortant') return

  const number = String(phone || '').replace(/\s+/g, '')
  if (!number) return

  // Simule un clic sur <a href="tel:…"> pour laisser l'OS ouvrir le composeur
  // sans détourner la navigation de l'application.
  const anchor = document.createElement('a')
  anchor.href = `tel:${number}`
  anchor.style.display = 'none'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
}
